import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';

const userService = {
  getUser() {
    return axios.post('users/me');
  },
  getUsers() {
    // por enquanto, deixa esse método porque ele está sendo utilizado em algum lugar e não temos tempo de refatorar esse endpoint
    return axios.get('users');
  },
  updateUser({id, data}) {
    return axios.patch(`users/${ id }`, {user: data});
  },
};

export default userService;



// WEBPACK FOOTER //
// ./src/services/UserService.js